import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { VaCardsModule } from '@vendasta/uikit';
import { HomePageCardContentComponent } from './home-page-card-content/home-page-card-content.component';
import { HomePageCardFooterComponent } from './home-page-card-footer/home-page-card-footer.component';
import { HomePageCardComponent } from './home-page-card/home-page-card.component';
import { HomePageCardHeaderComponent } from './home-page-title/home-page-card-header.component';

@NgModule({
  imports: [VaCardsModule, CommonModule, RouterModule, MatIconModule, TranslateModule, MatButtonModule],
  declarations: [
    HomePageCardComponent,
    HomePageCardHeaderComponent,
    HomePageCardFooterComponent,
    HomePageCardContentComponent,
  ],
  exports: [
    HomePageCardComponent,
    HomePageCardHeaderComponent,
    HomePageCardFooterComponent,
    HomePageCardContentComponent,
  ],
})
export class HomePageCardsModule {}
